<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        @headersUpdated="updateHeaders"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
      >
        <FormOrder
          ref="formOrder"
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
        />
      </v-dialog>

      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import FormOrder from "@/components/Complement/FormOrder";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import currentAccounts from "@/store/currentAccounts/currentAccounts.js";
import conceptsModel from "@/models/cuentasCorrientes/Relations/concepts";
import concepts from "@/store/conceptos/concepts";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import costCenters from "@/store/centrosDeCosto/costCenters";

export default {
  components: {
    Table,
    FormOrder,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.concepts"),
      titleTable: "Cuentas_Corrientes__Conceptos",
      titleDelete: this.$tc("CurrentAccounts.toConceptToAccount"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "nameConcept",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Centro de costo",
          value: "nameCostCenter",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo",
          value: "debCred",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fórmula",
          value: "formula",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Param. A",
          value: "paramA",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Param. B",
          value: "paramB",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      debCred: [
        {
          text: "Debito",
          value: "D",
        },
        {
          text: "Credito",
          value: "C",
        },
      ],
      changeDebCred: null,
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await concepts.dispatch("getConcepts");
    await costCenters.dispatch("getCostCenters");
    this.isLoading = false;
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },

    items() {
      if (
        !currentAccounts.state.edit.concepts ||
        currentAccounts.state.edit.concepts.length === 0
      ) {
        return [];
      } else {
        return currentAccounts.state.edit.concepts?.map((item) => {
          return conceptsModel.fromJson(item);
        });
      }
    },

    filteredConcepts() {
      const unit = currentAccounts.state.edit.unit;
      return concepts.state.concepts.filter((concept) => {
        if (unit === "H") {
          return concept.fullDayLicense === "N";
        } else if (unit === "D") {
          return concept.fullDayLicense === "S";
        }
        return false;
      });
    },

    costCenters() {
      return costCenters.state.costCenters;
    },

    editConcepts() {
      return currentAccounts.state.edit.concepts;
    },

    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "conceptos",
            type: "select",
            label: this.$tc("CurrentAccounts.conceptLabel"),
            items: this.filteredConcepts,
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
            multiple: true,
            disabled: false,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "csCostoId",
            type: "select",
            label: this.$tc("CurrentAccounts.centroCostoLabel"),
            items: this.costCenters,
            itemText: "name",
            itemValue: "id",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
          {
            id: 3,
            show: true,
            data: currentAccounts.state.edit.unit !== "D" ? "00:00" : 0,
            name: "paramA",
            type: "text",
            typeInput:
              currentAccounts.state.edit.unit === "D" ? "number" : "time",
            label: this.$tc("CurrentAccounts.paramALabel"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
              ...(currentAccounts.state.edit.unit === "D"
                ? [(v) => v >= 0 || this.$tc("CurrentAccounts.minValueZero")]
                : [
                    (v) =>
                      /^(\d{1,3}):([0-5][0-9])$/.test(v) ||
                      this.$tc("CurrentAccounts.invalidTimeFormat"),
                  ]),
            ],
            order: 3,
          },
          {
            id: 4,
            show: true,
            data: 1,
            name: "paramB",
            type: "text",
            typeInput: "number",
            label: this.$tc("CurrentAccounts.paramBLabel"),
            items: [],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
              (v) => v >= 1 || this.$tc("CurrentAccounts.minValueOne"),
            ],
            order: 4,
          },

          {
            id: 5,
            show: true,
            data: "",
            name: "debCred",
            type: "select",
            label: this.$tc("CurrentAccounts.debCredLabel"),
            items: this.debCred,
            itemText: "text",
            itemValue: "value",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 5,
          },
        ],
      };
    },
    mode: {
      get() {
        return currentAccounts.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return currentAccounts.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return currentAccounts.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },

    async refreshItems() {
      if (currentAccounts.state.edit.accountId) {
        await currentAccounts.dispatch(
          "getAccountId",
          currentAccounts.state.edit.accountId
        );
      }
    },

    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },

    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    editConcept(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.accountId = currentAccounts.state.edit.accountId;
        payload.conceptId = this.oldItems.conceptId;
        payload.oldCostCenterId = this.oldItems.costCenterId;

        if (this.changeDebCred !== null) {
          payload.formula =
            this.changeDebCred +
            " [" +
            form.paramA +
            "] + [" +
            form.paramB +
            "] * Cantidad en Concepto";
        }

        currentAccounts.commit("setEditRelation", payload);
        currentAccounts
          .dispatch("editConcept")
          .then(() => {
            this.showAlert(
              this.$tc("CurrentAccounts.editConceptToAccountSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#ff8d58");
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }
      this.reset(false);
    },

    detectChanges(newItems) {
      const changes = {};
      if (
        newItems.hasOwnProperty("debCred") ||
        newItems.hasOwnProperty("paramA") ||
        newItems.hasOwnProperty("paramB")
      ) {
        if (this.oldItems.debCred !== newItems.debCred) {
          changes.debCred = newItems.debCred;
          if (newItems.debCred === "D") {
            this.changeDebCred = "[Debita]";
          } else {
            this.changeDebCred = "[Acredita]";
          }
        } else {
          if (this.oldItems.debCred === "D") {
            this.changeDebCred = "[Debita]";
          } else {
            this.changeDebCred = "[Acredita]";
          }
        }

        if (currentAccounts.state.edit.unit !== "D") {
          if (
            this.convertToMinutes(this.oldItems.paramA) !==
            this.convertToMinutes(newItems.paramA)
          ) {
            changes.paramA = this.convertToMinutes(newItems.paramA);
          }
        } else {
          if (this.oldItems.paramA !== Number(newItems.paramA)) {
            changes.paramA = Number(newItems.paramA);
          }
        }

        if (this.oldItems.paramB !== Number(newItems.paramB)) {
          changes.paramB = Number(newItems.paramB);
        }
        if (newItems.debCred === "D") {
          this.changeDebCred = "[Debita]";
        } else {
          this.changeDebCred = "[Acredita]";
        }
      }
      if (this.oldItems.costCenterId !== Number(newItems.csCostoId)) {
        changes.costCenterId = Number(newItems.csCostoId);
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.parameters.items[0].items = this.filteredConcepts;
          this.parameters.items[0].disabled = false;
          currentAccounts.commit(
            "setModeFormRelation",
            this.$tc("CurrentAccounts.addConceptToAccount")
          );
          currentAccounts.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.oldItems = item;
          this.parameters.items[0].items = this.filteredConcepts;
          this.parameters.items[0].data = [item.conceptId];
          this.parameters.items[0].disabled = true;
          this.parameters.items[1].data = item.costCenterId;
          this.parameters.items[2].data = item.paramA;
          this.parameters.items[3].data = item.paramB;
          this.parameters.items[4].data = item.debCred;
          currentAccounts.commit(
            "setModeFormRelation",
            this.$tc("CurrentAccounts.editConceptToAccount")
          );
          currentAccounts.commit("setOpenFormRelation", true);
          break;
        case "delete":
          currentAccounts.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            accountId: currentAccounts.state.edit.accountId,
          };
          break;
        default:
          break;
      }
    },

    reset(value) {
      currentAccounts.commit("setOpenFormRelation", value);
      this.parameters.items.forEach((item) => {
        if (item.name === "paramA") {
          item.data = currentAccounts.state.edit.unit !== "D" ? "00:00" : 0;
        } else if (item.name === "paramB") {
          item.data = 1;
        } else {
          item.data = "";
        }
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addConcept(items);
          break;
        case "edit":
          this.editConcept(items);
          break;
        default:
          break;
      }
    },

    convertToMinutes(timeString) {
      const [hours, minutes] = timeString.split(":").map(Number);
      return hours * 60 + minutes;
    },

    async addConcept(form) {
      form.paramA =
        currentAccounts.state.edit.unit === "D"
          ? form.paramA
          : this.convertToMinutes(form.paramA);

      let payload = {
        ...form,
        formula:
          form.debCred === "D"
            ? "[Debita] [" +
              form.paramA +
              "] + [" +
              form.paramB +
              "] * Cantidad en Concepto"
            : "[Acredita] [" +
              form.paramA +
              "] + [" +
              form.paramB +
              "] * Cantidad en Concepto",
        accountId: currentAccounts.state.edit.accountId,
      };
      currentAccounts.commit("setNew", payload);
      currentAccounts
        .dispatch("addConcept")
        .then(() => {
          concepts.dispatch("getConcepts");
          this.showAlert(
            this.$tc("CurrentAccounts.addConceptToAccountSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },

    deleteItem() {
      currentAccounts.commit("setItemDelete", this.itemToDelete);
      currentAccounts
        .dispatch("deleteConcept")
        .then(() => {
          this.openDelete = false;
          currentAccounts.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("CurrentAccounts.deleteConceptToAccountSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      currentAccounts.commit("setOpenDelete", false);
    },
  },
};
</script>
